module.exports = __webpack_public_path__ + "static/magician-02-d5b70702007f5643e4799108bbdf8284.png";